import BaseHeader from './BaseHeader';

export default BaseHeader;
